import './SafetyCard.less';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Card, AppLocaleProvider, Row, Col } from 'sd-ui-components';

const { FormattedNumber } = AppLocaleProvider;

@inject('SafetyStore')
@observer
class TargetScoreCard extends React.Component {
  render() {
    const { SafetyStore } = this.props;

    return (
      <div>
        <Card
          className="target-box safety-card"
          data-automation-id="sd-ui-driver-safety-target-score-card"
          loading={SafetyStore.loading.getSafetyScore}
        >
          <Row>
            <Col span={24}>
              <h4 className="target-score-card-title">Target score</h4>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="target-score-container">
                <span className="target-safety-score">
                  <FormattedNumber
                    value={SafetyStore.safetyData.targetScore}
                    useGrouping={false}
                  />
                </span>
                {!SafetyStore.targetScoreIsNull && (
                  <span
                    data-automation-id="sd-ui-driver-safety-target-score-card"
                    className="target-score-text"
                  >
                    <br />
                    {SafetyStore.driverScoreIsNull
                      ? 'Your goal is to score below this target'
                      : SafetyStore.safetyData.driverScore <
                        SafetyStore.safetyData.targetScore
                      ? `Great job! You are beating your target`
                      : `Improve your score by 
                    ${SafetyStore.safetyData.driverScore -
                      SafetyStore.safetyData.targetScore} to meet target.`}
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}

export default TargetScoreCard;



// WEBPACK FOOTER //
// ./src/containers/Safety/SafetyCards/TargetScoreCard.jsx